var chunkMapping = {
	"1": [
		15,
		1271,
		1452,
		2653,
		3152,
		3177,
		5333,
		5515,
		6941
	],
	"4": [
		5004
	],
	"11": [
		2011
	],
	"31": [
		31
	],
	"35": [
		8035
	],
	"47": [
		9047
	],
	"83": [
		83
	],
	"104": [
		104
	],
	"115": [
		115
	],
	"129": [
		6129
	],
	"147": [
		7147
	],
	"161": [
		8161
	],
	"194": [
		2194
	],
	"210": [
		1210
	],
	"216": [
		216
	],
	"219": [
		3219
	],
	"222": [
		4222
	],
	"263": [
		3263
	],
	"278": [
		3278
	],
	"420": [
		8420
	],
	"465": [
		7465
	],
	"507": [
		9507
	],
	"510": [
		4510
	],
	"578": [
		1578
	],
	"580": [
		2580
	],
	"595": [
		7595
	],
	"646": [
		9646
	],
	"653": [
		5034
	],
	"699": [
		5699
	],
	"700": [
		3700
	],
	"701": [
		6701
	],
	"721": [
		4721
	],
	"915": [
		6915
	],
	"919": [
		9919
	],
	"926": [
		2926
	],
	"958": [
		6958
	],
	"988": [
		3988
	],
	"991": [
		4991
	]
};
var idToExternalAndNameMapping = {
	"15": [
		"default",
		"./store",
		2682
	],
	"31": [
		"default",
		"./Provider",
		2302
	],
	"83": [
		"default",
		"./InsurancesAdmin",
		9810
	],
	"104": [
		"default",
		"./ConfirmationForm",
		9810
	],
	"115": [
		"default",
		"./BillingAdmin",
		9810
	],
	"216": [
		"default",
		"./UsersAdmin",
		9810
	],
	"1210": [
		"default",
		"./ReportsSummaries",
		9810
	],
	"1271": [
		"default",
		"./fnxUtils",
		2682
	],
	"1452": [
		"default",
		"./LocalStorage",
		2682
	],
	"1578": [
		"default",
		"./CollectAdmin",
		9810
	],
	"2011": [
		"default",
		"./PropertiesAdmin",
		9810
	],
	"2194": [
		"default",
		"./CobranzaAdmin",
		9810
	],
	"2580": [
		"default",
		"./Completed",
		9810
	],
	"2653": [
		"default",
		"./WorkflowApp",
		5521
	],
	"2926": [
		"default",
		"./CalculatePremium",
		9810
	],
	"3152": [
		"default",
		"./Loading",
		2682
	],
	"3177": [
		"default",
		"./WorkflowCreateApp",
		5521
	],
	"3219": [
		"default",
		"./CustomReportPage",
		9810
	],
	"3263": [
		"default",
		"./AccountTypeAdmin",
		9810
	],
	"3278": [
		"default",
		"./BranchesAdmin",
		9810
	],
	"3700": [
		"default",
		"./InsuranceTypeAdmin",
		9810
	],
	"3988": [
		"default",
		"./CataloguesAdmin",
		9810
	],
	"4222": [
		"default",
		"./RegionAdmin",
		9810
	],
	"4510": [
		"default",
		"./PaymentConfirmation",
		9810
	],
	"4721": [
		"default",
		"./PassengerForm",
		9810
	],
	"4991": [
		"default",
		"./Clients",
		9810
	],
	"5004": [
		"default",
		"./AddBusiness",
		9810
	],
	"5034": [
		"default",
		"./RolAdmin",
		9810
	],
	"5333": [
		"default",
		"./FormsApp",
		8497
	],
	"5515": [
		"default",
		"./FlowApp",
		3301
	],
	"5699": [
		"default",
		"./InsurancePoliciesSummary",
		9810
	],
	"6129": [
		"default",
		"./PermissionAdmin",
		9810
	],
	"6701": [
		"default",
		"./ProjectTypeAdmin",
		9810
	],
	"6915": [
		"default",
		"./ClientRecord",
		9810
	],
	"6941": [
		"default",
		"./NotFound",
		2682
	],
	"6958": [
		"default",
		"./CustomerForms",
		9810
	],
	"7147": [
		"default",
		"./MasterApp",
		1033
	],
	"7465": [
		"default",
		"./PlanAdmin",
		9810
	],
	"7595": [
		"default",
		"./InitialInfo",
		9810
	],
	"8035": [
		"default",
		"./AuditPage",
		9810
	],
	"8161": [
		"default",
		"./ProductCreation",
		9810
	],
	"8420": [
		"default",
		"./Plan",
		9810
	],
	"9047": [
		"default",
		"./authApp",
		2302
	],
	"9507": [
		"default",
		"./PaymentSummary",
		9810
	],
	"9646": [
		"default",
		"./PlanDetails",
		9810
	],
	"9919": [
		"default",
		"./PlanCreation",
		9810
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}